import { Button } from '@material-ui/core'
import styled, { css } from 'styled-components'

const StyledButton = styled(Button) <{ $selected?: boolean }>`
	&&& {
		padding: 6px;
		min-width: 0;
		min-height: 0;

		${p => p.$selected && css`
		background: rgba(255, 255, 255,0.25);
		`}
	}
`

export default StyledButton